/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import downArrow from "./../../../images/down-arrow.png";
import Select, {components} from "react-select";
import { defaultTheme } from "react-select";
import USA from "./../../../images/USA.png";
import Accordion from "react-bootstrap/Accordion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CountryDropdown.css";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "@mywvglobal-shared/mywv-shared/action/countryListAction";
import { useTranslation } from "react-i18next";
import * as PersistItemsAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import { useParams } from "react-router-dom";

const { colors } = defaultTheme;
const { Option } = components;

const selectStyles = {
  control: styles => ({ ...styles, margin: 8,    //removed for mobile screens minWidth: 240 
    backgroundColor: "rgba(255, 255, 255, 0.98)",
    border: "0.5px solid rgba(118, 115, 115, 0.8)" }),
  input: (base) => ({
      ...base,
      "[type=\"text\"]": {
        fontSize: 13,
        fontWeight: 700,
        color: "#000 !important"
      }
    }),
  menu: (styles) => ({ ...styles, background: "rgba(36, 32, 32, 0.98)",
    border: "0.5px solid rgba(118, 115, 115, 0.8)",
    borderBottom: "unset",
    bordeRadius: "5px",
    }),
  option: (styles, state) => ({
    ...styles,
    display: "flex",
    alignItems: "center",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    borderBottom: "0.5px solid rgba(118, 115, 115, 0.7)",
    backgroundColor: state.isActive ? "rgba(36, 32, 32, 0.98)" :  "rgba(36, 32, 32, 0.98)",
  }),
 
};

function CountryDropdown (props) {
  const [isOpen, setIsOpen]= useState(false);
  const [value, setValue]= useState(undefined);
  const [options, setOptions]= useState([]);
  const { countryListReducer } = useSelector((state) => state);
  const { supportOfficeList } = countryListReducer?.countryList?.serviceResponse ?? [];
  const [setErrorMessage] = useState(null);
  const [setIsErrorOccured] = useState(false);
  const { persistItemsReducer } = useSelector((state) => state);
  const { loggedInCountryHistoryList } = persistItemsReducer ?? [];
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const params = useParams();
  
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  }

  const onSelectChange = async (value) => {
    setIsOpen(false);
    setValue(value);
    const SoDetails = {
      soFlag: value?.soFlag,
      soName: value?.soName,
      soCode: value?.soCode,
      soLanguageCode: value?.supportedLanguages[0]?.languageCode,
      soLanguageCultureCode: value?.supportedLanguages[0]?.cultureCode,
      shortLanguageCode: value?.supportedLanguages[0]?.shortLanguageCode,
    }
    const selectedSOData = {
      soCode: value?.soCode,
      languageCode: value?.supportedLanguages[0]?.languageCode,
      soFlag: value?.soFlag,
      soName: value?.soName,
      soLanguageCultureCode: value?.supportedLanguages[0]?.cultureCode,
      shortLanguageCode: value?.supportedLanguages[0]?.shortLanguageCode,
    };
    const param = {
      ...persistItemsReducer,
      isLoggedIn: false,
      selectedSOData,
    }

    await dispatch(PersistItemsAction.loginPersist(param));
    await dispatch(PersistItemsAction.logoutPersist()); 
    props.setSoDetails(SoDetails)
  }

  const handleSelectLang=(value)=>{
    setIsOpen(false);
    setValue(value);
  }
  
  const fetchCountryList = () => {
        const param = {
          baseURL: process.env.REACT_APP_BASE_URL,
          appVersion: "28",
          deviceType: "web",
          officeCode: params?.soname??"",
        };
        dispatch(Action.countryListRequest(param));
  };

  useEffect(() => {
    if (countryListReducer?.errorMessage?.data) {
      setErrorMessage("Generic Error");
      setIsErrorOccured(true);
    }
  }, [countryListReducer?.errorMessage?.data]);

  useEffect(() => {
    fetchCountryList();
  }, []);

  useEffect(() => {
    let soListWithHistory=[]
    let loggedInCountryHistoryList2=loggedInCountryHistoryList?.slice(0,1)
    soListWithHistory = supportOfficeList?.filter((el) => {
      return loggedInCountryHistoryList2?.some((f) => {
        return el?.soCode === f?.soCode 
      });
    });
    
    soListWithHistory= 
      soListWithHistory?.concat(supportOfficeList?.filter(val => soListWithHistory?.every(so => so?.soCode != val?.soCode)))
    
    setOptions(soListWithHistory?.map(item=>{
      return({value: item?.soName,...item})
    }));
    soListWithHistory?setValue(soListWithHistory[0]):null
    // if(soListWithHistory && soListWithHistory.length===1){
      onSelectChange(soListWithHistory?soListWithHistory[0]:null);
    // }else{
      // onSelectChange(soListWithHistory?soListWithHistory[0]:null);
      //have to be select from SO selected history
    // }
  }, [supportOfficeList]);

  const onLanguageClick = (item, languageCode, cultureCode) => {
    const SoDetails = {
      soFlag: item?.soFlag,
      soName: item?.soName,
      soCode: item?.soCode,
      soLanguageCode: languageCode,
      soLanguageCultureCode: cultureCode,
    }
    props.setSoDetails(SoDetails);
  };

  const groupedOptions= [
    {
      label: loggedInCountryHistoryList?.length>0? t("DT_WVM_CFIG_HEAD_00002_LastUsed"): null,
      options: options? options: [],
    },
  ];

  const IconOption = props => (
    {...props.data.supportedLanguages.length > 1 ?  
      <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
        {props.data.soFlag && <img src={props.data.soFlag} style={{ width: "27px", height: "17px", marginRight: "10px" }}
          alt={props.data.soName}
        />}
        {props.data.soName}</Accordion.Header>
        <Accordion.Body>
         <span className="select-lang-text">Select your Language</span>
         {props.data.supportedLanguages.map((lang)=>{
          return(<p key={lang.cultureCode} 
                    className="lang-name" 
                    onClick={()=>{handleSelectLang({...props.data, supportedLanguages:[lang]}); 
                                  onLanguageClick(props.data, lang.languageCode, lang.cultureCode)}}
                  >
                    {lang.languageName}</p>)
         })}
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
    :
     <Option {...props}>
     {props.data.soFlag && <img
      src={props.data.soFlag}
      style={{ width: "27px", height: "17px", marginRight: "10px" }}
      alt={props.data.soName}
    />}      
      {props.data.soName}
    </Option> }  
  );

  if(supportOfficeList?.length>1){
      return (
      <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <Button
          className="lang-button"
          onClick={toggleOpen}
        >
          {value ?  <span style={{display: "flex", alignItems: "center"}}>
              {value.soFlag && <img src={value.soFlag} style={{marginRight: "5px", width: "27px", height: "17px"}} alt="country-flag"/>}
               <span className="selected-lang">{value?.soName}</span>
              <img src={downArrow} alt="down-arrow" style={{right: "15px", position: "absolute"}}/>
            </span> : 
            <span style={{display: "flex", alignItems: "center"}}>
              {USA && <img src={USA} style={{marginRight: "5px", width: "27px", height: "17px"}} alt="country-flag"/>}
              {/* <span>{"USA"}</span> */}
              {downArrow && <img src={downArrow} alt="down-arrow" style={{right: "15px", position: "absolute"}}/>}              
            </span>
            }
        </Button>
      }
    >
      <Select
        backspaceRemovesValue={false}
        components={{Group, DropdownIndicator, IndicatorSeparator: null,  Option: IconOption }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={onSelectChange}
        options={groupedOptions}
        placeholder={t("DT_WVM_CFIG_HEAD_00007_Sear")}
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
    )}
    else{
    return <>
            <Button
              className="lang-button"
            >
               <span style={{display: "flex", alignItems: "center"}}>
                {value?.soFlag && <img src={value?.soFlag} style={{marginRight: "5px", width: "27px", height: "17px"}} alt="country-flag"/>}
                <span className="selected-lang">{value?.soName}</span>
              </span>

        </Button>
            
        </>
  }}
  
export default CountryDropdown;
// styled components

const Menu = props => {
  return (
    <div
    className="countryMenu"
      {...props}
    />
  );
};
const Blanket = props => (
  <div
  className="blanket"
    {...props}
  />
);
const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div style={{ position: "relative" }}>
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
const Svg = p => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
const DropdownIndicator = () => (
  <div style={{ color: colors.neutral20, height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);

const Group = (props) => (
  <div>
    <components.Group {...props} />
  </div>
);
